import { atom } from "jotai";
import { appStore } from "./store";

/**
 * In-app popup for the legal documents (FSD: policies must not navigate the
 * user away from an active booking/checkout). The real pages under
 * /terms-and-conditions and /cookie-policy are kept untouched because the
 * mobile app embeds them in a WebView.
 */
export type TLegalDoc =
  | "privacy-policy"
  | "cookie-policy"
  | "terms-of-use"
  | "passenger-charter";

/** Document currently shown in the popup, or null when closed. */
export const legalDocModalAtom = atom<TLegalDoc | null>(null);

/** Opens the legal popup. Callable from React and non-React code (Actions). */
export const openLegalDoc = (doc: TLegalDoc): void => {
  appStore.set(legalDocModalAtom, doc);
};

const TERMS_TAB_DOCS: readonly string[] = [
  "privacy-policy",
  "terms-of-use",
  "passenger-charter",
];

/** Maps an internal legal-page route to the document it shows, else null. */
export const legalDocFromPath = (path: string): TLegalDoc | null => {
  if (path === "/cookie-policy" || path.startsWith("/cookie-policy?")) {
    return "cookie-policy";
  }
  if (path === "/terms-and-conditions") {
    // The page defaults to the passenger charter tab.
    return "passenger-charter";
  }
  const tab = path.match(/^\/terms-and-conditions\?(?:.*&)?tab=([a-z-]+)/)?.[1];
  return tab && TERMS_TAB_DOCS.includes(tab) ? (tab as TLegalDoc) : null;
};
